import React from "react";
import cx from "classnames";
import {
  uploadSpsAPiRequest,
  uploadSpsMetadataAPiRequest,
  spsApiPost,
  getSpsAPiRequest
} from "../../../utils/api_service";
import { getSharepointUrl } from "./sharepoint_api";
import { AttachFileOutlined } from "@material-ui/icons";
const AllowedExtensions =
  ".gif,.jpg,.jpeg,.png,.doc,.docx,.pdf,.csv,.xls,.xlsx";
const MaxFileSize = 31457280;
const FileSizeErrorMsg =
  "File size should be less than 30MB. Please visit to portal for uploading.";

class FileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: [],
      checkedItems: new Map()
    };

    // optionData = [{ key: 1, label: "Keep Both" }, { key: 2, label: "Replace" }];
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.selectedCategory !== nextProps.selectedCategory) {
      this.setState({ selectedFile: [] });
    }
  }

  /** validate file */
  async validateFile(fileObj) {
    let flag = false;
    let errorMsg = "";
    const curFileExt = fileObj.name
      .substring(fileObj.name.lastIndexOf("."))
      .toLowerCase();
    if (AllowedExtensions.split(",").indexOf(curFileExt) < 0) {
      errorMsg = curFileExt + " type files not allowed";
    } else if (fileObj.size > MaxFileSize) {
      errorMsg = FileSizeErrorMsg;
    } else {
      flag = true;
    }

    const isFieExist = this.isFileExists(fileObj.name);
    const canUpload = !flag ? flag : flag && !isFieExist;
    const value = {
      fileData: fileObj,
      isFileExist: isFieExist,
      message: errorMsg,
      isFileReplace: false,
      isValid: flag,
      canUpload: canUpload,
      fileAction: 0
    }; // [...this.state.selectedFile, { "IsValid": flag, "Message": errorMsg, fileData: fileObj }]

    this.setState(prevState => ({
      selectedFile: prevState.selectedFile.concat(value)
    }));

    return flag;
  }

  // On file select (from the pop up)
  /** call on file change */
  onFileChange = event => {
    this.setState({ selectedFile: [], checkedItems: new Map() });
    if (event.target && !event.target.files.length) return;
    Array.from(event.target.files).map(file => {
      this.validateFile(file);
    });

    setTimeout(() => {
      this.props.setUploadFilesList(this.state.selectedFile);
    }, 3);

    event.target.value = "";
  };

  /** upload visibility check */
  isUploadDisable = () => {
    try {
      let validFileCnt = 0;
      let canUploadFileCnt = 0;
      this.state.selectedFile.map(item => {
        if (item.isValid) validFileCnt++;
        if (item.canUpload) canUploadFileCnt++;
      });
      return !(validFileCnt == canUploadFileCnt && validFileCnt > 0);
    } catch (e) {
      return true;
    }
  };

  /** On file upload (click the upload button) */
  onFileUpload = () => {
    this.closeModal();
    // const userPref = localStorage.getItem("userPreference");
    // const emailId = userPref ? JSON.parse(userPref).emailId : "";

    const filesToUpload = this.state.selectedFile.filter(item => {
      return item.canUpload;
    });

    if (filesToUpload.length > 0) {
      for (let index = 0; index < filesToUpload.length; index++) {
        spsApiPost({
          url: getSharepointUrl(
            "uploadFileSession",
            "123",
            filesToUpload[index].fileData.name
          ),
          postBody: {
            fileSize: filesToUpload[index].fileData.size,
            item: {
              "@microsoft.graph.conflictBehavior":
                this.state.checkedItems.get(
                  filesToUpload[index].fileData.name
                ) == 1
                  ? "rename"
                  : "replace"
            }
          }
        }).then(data => {
          if (data) {
            uploadSpsAPiRequest(
              data.data.uploadUrl,
              filesToUpload[index].fileData,
              this.state.checkedItems,
              true
            ).then(data => {
              if (data) {
                // ShowToast("File uploaded successfully.", toastType.SUCCESS);
                // this.getList(data.name, emailId);
              }
            });
          }
        });
      }
    }
  };

  /** get list */
  getList = (fileName, emailId) => {
    getSpsAPiRequest(
      getSharepointUrl("getSps", this.props.selectedPropertyKey)
    ).then(spsDataRes => {
      if (spsDataRes) {
        const { value } = spsDataRes;
        for (let i = 0; i < value.length; i++) {
          if (fileName === value[i].name) {
            this.updateMetaData(value[i].listItem.id, emailId);
            break;
          }
        }
      }
    });
  };

  /** Function to update meta data values */
  updateMetaData = (itemId, emailId = "") => {
    const metadata = {
      FileType: this.props.selectedCategory,
      UserEmail: emailId
    };
    uploadSpsMetadataAPiRequest(
      getSharepointUrl(
        "uploadMetadata",
        this.props.selectedPropertyKey,
        itemId
      ),
      metadata
    ).then(() => {
      this.setState({ selectedFile: [] });
      this.props.getSpsData();
    });
  };

  /** remove file */
  removeFile = index => {
    const {selectedFile} =this.state;
    const list = [...selectedFile];
    list.splice(index, 1);
    this.setState({ selectedFile: list });
    if (list.length == 0) {
      this.closeModal();
    }
  };

  /** check file */
  isFileExists(filename) {
    if (this.props.spsAllData.value) {
      return (
        this.props.spsAllData.value.filter(data => {
          return data.name == filename;
        }).length > 0
      );
    }
    return false;
  }


  /** call on check box value change */
  handleCheckboxChange(e) {
    const item = e.target.name;
    const isChecked = e.target.checked;
    this.setState(prevState => ({
      checkedItems: prevState.checkedItems.set(item, isChecked)
    }));
  }

  /** Call on file action change */
  onFileActionChange = (value, valueKey) => {
    this.setState(prevState => ({
      checkedItems: prevState.checkedItems.set(valueKey, value)
    }));
    const {selectedFile} =this.state;

    const list = [...selectedFile];
    const index = list.findIndex(item => item.fileData.name == valueKey);
    list[index].canUpload = value > 0;
    this.setState({ selectedFile: list });
  };

  /** upload check box handle */
  handleUploadCheckboxChange(e) {
    const item = e.target.name;
    const {selectedFile} =this.state;

    const list = [...selectedFile];
    list[item].canUpload = e.target.checked;
    this.setState({ selectedFile: list });
  }

  closeModal = () => {
    // this.setState({ fullScreenOn: false });
  };
  // File content to be displayed after
  // file upload is complete

  render() {
    const { disabled, showUploadBtn = false, uploadFiles } = this.props;

    return (
      <div className={"fileUploadContainer"}>
        <div className={"upload-header"}>
          <div>
            <label
              htmlFor={"files"}
              className={cx("select-button", disabled && "disabled")}
            >
              <span>
                <AttachFileOutlined fontSize={"inherit"} />
                {"Add Attachment\r"}
              </span>
            </label>

            {showUploadBtn ? (
              <label
                className={cx("select-button", disabled && "disabled")}
                onClick={uploadFiles}
              >
                <span className={"upload-btn"}>{"Upload Attachment"}</span>
              </label>
            ) : (
              ""
            )}
            <input
              type={"file"}
              id={"files"}
              className={"fileInput"}
              multiple
              onChange={this.onFileChange}
              accept={AllowedExtensions}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default FileUpload;
